export const Constants = {
  TAG_NAME: 'pop-product-center-line-chart',
} as const;
